import Note from './Note'
import Tips from './Tips'
import Warning from './Warning'
import NavColumns from './NavColumns'
import NavColumn from './NavColumn'
import ColumnTitle from './ColumnTitle'
import WithCopy from './WithCopy'
import DataRender from './DataRender';
import CodeBlock from './CodeBlock';
import Code from './Code';
import { Collapse, Tabs, Typography } from 'antd';

const { Panel } = Collapse
const { TabPanel } = Tabs
const { Text, Link } = Typography

export {
  Note,
  Warning,
  Tips,
  NavColumns,
  NavColumn,
  ColumnTitle,
  WithCopy,
  Collapse,
  Panel,
  Tabs,
  TabPanel,
  Text,
  Link,
  DataRender,
  CodeBlock,
  Code,
}
